import createSvgIcon from "./utils/create_icon"

const EditOutline = createSvgIcon(<path clipRule="evenodd" d="M17.707 3.293a1 1 0 0 0-1.414 0l-3 3-10 10A1 1 0 0 0 3 17v3a1 1 0 0 0 1 1h3a1 1 0 0 0 .707-.293l10-10 3-3a1 1 0 0 0 0-1.414zM17 8.586 18.586 7 17 5.414 15.414 7zm-3-.172-9 9V19h1.586l9-9z" fill="currentColor" fillRule="evenodd" />, "EditOutline")
export default EditOutline
